import React from 'react';
import { Badge } from '@/components/ui/badge';
import type { TemplateVisibility } from '@/types/WeeklyReport';
import { Lock, Users, Globe } from 'lucide-react';

interface TemplateVisibilityBadgeProps {
    visibility?: TemplateVisibility;
    showLabel?: boolean;
    size?: 'sm' | 'default';
}

const visibilityConfig: Record<TemplateVisibility, {
    icon: React.ReactNode;
    label: string;
    variant: 'default' | 'secondary' | 'outline';
    className: string;
}> = {
    private: {
        icon: <Lock size={12} />,
        label: 'Private',
        variant: 'outline',
        className: 'text-muted-foreground'
    },
    shared: {
        icon: <Users size={12} />,
        label: 'Shared',
        variant: 'secondary',
        className: 'text-blue-600 dark:text-blue-400 border-blue-200 dark:border-blue-800'
    },
    organization: {
        icon: <Globe size={12} />,
        label: 'Organization',
        variant: 'default',
        className: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-100 border-amber-200 dark:border-amber-800'
    }
};

export const TemplateVisibilityBadge: React.FC<TemplateVisibilityBadgeProps> = ({
    visibility = 'private',
    showLabel = true,
    size = 'default'
}) => {
    const config = visibilityConfig[visibility];
    
    return (
        <Badge
            variant="outline"
            className={`flex items-center gap-1 ${config.className} ${size === 'sm' ? 'h-5 text-xs px-1.5' : ''}`}
        >
            {config.icon}
            {showLabel && <span>{config.label}</span>}
        </Badge>
    );
};

export default TemplateVisibilityBadge;

